"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmModal = void 0;
const react_1 = __importDefault(require("react"));
const ConfirmModal = ({ message, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel', }) => {
    return (react_1.default.createElement("div", { className: "cw-modal-overlay", onClick: onCancel },
        react_1.default.createElement("div", { className: "cw-modal", onClick: (e) => e.stopPropagation() },
            react_1.default.createElement("p", null, message),
            react_1.default.createElement("div", { className: "cw-modal-actions" }, onConfirm ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("button", { className: "cw-modal-btn cw-modal-btn-cancel", onClick: onCancel }, cancelLabel),
                react_1.default.createElement("button", { className: "cw-modal-btn cw-modal-btn-confirm", onClick: () => { onConfirm(); onCancel(); } }, confirmLabel))) : (react_1.default.createElement("button", { className: "cw-modal-btn cw-modal-btn-confirm", onClick: onCancel }, "OK"))))));
};
exports.ConfirmModal = ConfirmModal;
